import { createContext } from "react";

export const WarehousesContext = createContext();
